<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="metrologicalMonitor">
			<template #ops>
				<el-button type="primary" @click="handleExport">导 出</el-button>
			</template>
		</gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					ref="advancedFilter"
					v-model="form"
					:fields="filterFields"
					@search="handleFilterSearch"
					@reset="handleFilterReset"
				/>
				<gc-column-setting
					:storageKey="`localcolumn-metrological-monitor`"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show">
				<gc-table
					:columns="columnList"
					:table-data="tableData"
					:border="true"
					:showPage="true"
					:total="page.total"
					:page-size="page.size"
					:currentPage="page.current"
					@current-page-change="
						currentPage => {
							currentPageChange(currentPage, apiMetrologicalMonitorList)
						}
					"
					@size-change="
						size => {
							page.size = size
							currentPageChange(1, apiMetrologicalMonitorList)
						}
					"
				></gc-table>
			</div>
		</div>
	</div>
</template>

<script>
import common from '../mixins/common.js'
import { apiMetrologicalMonitorList } from '@/apis/alarm.api'
import { exportReport } from '@/apis/statisticAnalysis.api'
import { apiGetDeviceTypeList } from '@/apis/account.api'
import { isBlank } from '@/utils/validate'

export default {
	name: 'metrologicalMonitor',
	mixins: [common],
	data() {
		return {
			form: {
				deviceNo: null,
				designNo: null,
				userNo: null,
				userName: null,
				deviceTypeClassify: null,
				deviceTypeIdList: [],
				userType: null,
			},
			columns: [],
			searchOptions: {},
		}
	},
	mounted() {
		this.$set(this.searchOptions, 'userType', this.$store.getters.dataList.userType || [])
		this.getList(1, apiMetrologicalMonitorList)
	},
	methods: {
		apiMetrologicalMonitorList,

		async queryDeviceTypeList() {
			apiGetDeviceTypeList({ tenantId: this.tenantId, deviceTypeClassify: this.form.deviceTypeClassify }).then(
				res => {
					let list = res.records || []
					let val = list.map(item => {
						return {
							value: item.deviceTypeId,
							label: item.deviceTypeName,
						}
					})
					this.$set(this.searchOptions, 'deviceTypeId', val)
				},
			)
		},

		handleExport() {
			if (!this.tableData.length) return this.$message.warning('暂无表格数据')
			this.$toast('下载中，请稍后...')
			const params = {}
			for (let key in this.form) {
				if (!isBlank(this.form[key])) {
					params[key] = this.form[key]
				}
			}
			const data = {
				method: 'post',
				url: '/monitor/report/measurement-data/export/excel',
				fileName: '计量监控.xlsx',
				data: {
					...params,
					tenantType: this.tenantType,
				},
			}
			exportReport(data, 'excel', '', this.$toast)
		},

		handleFilterSearch() {
			this.getList(1, apiMetrologicalMonitorList)
		},

		handleFilterReset() {
			this.getList(1, apiMetrologicalMonitorList)
		},
	},
	computed: {
		filterFields() {
			return [
				{
					prop: 'deviceNo',
					label: '设备通讯编号',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'designNo',
					label: '外观编号',
					type: 'input',
				},
				{
					prop: 'userNo',
					label: '用户号',
					type: 'input',
				},
				{
					prop: 'deviceTypeClassify',
					label: '设备大类',
					type: 'select',
					props: {
						searchOption: this.$store.getters.dataList.deviceTypeClassify,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.deviceTypeId,
						filterable: true,
						multiple: true,
						needAllForSearch: true,
					},
				},
				{
					prop: 'userType',
					label: '客户类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.userType,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
				{
					prop: 'userName',
					label: '客户/站点名称',
					type: 'input',
				},
			]
		},

		pressureUnitName() {
			return this.$store.getters.pressureUnitName
		},

		columnList() {
			return this.columns.filter(o => o.selected)
		},

		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},
	},

	watch: {
		pressureUnitName: {
			handler() {
				this.columns = [
					{
						key: 'deviceNo',
						name: '设备通讯编号',
						width: 180,
						fixed: 'left',
						dragDisable: true,
						disabledSelect: true,
						tooltip: true,
					},
					{
						key: 'designNo',
						name: '外观编号',
						tooltip: true,
					},
					{
						key: 'deviceName',
						name: '设备类型',
						tooltip: true,
					},
					{
						key: 'userNo',
						name: '用户号',
						tooltip: true,
					},
					{
						key: 'userName',
						name: '客户/站点名称',
						tooltip: true,
					},
					{
						key: 'dataTime',
						name: '数据日期',
						width: 180,
					},
					{
						key: 'standardCumulativeFlow',
						name: '标况总量（m³）',
					},
					{
						key: 'workCumulativeFlow',
						name: '工况总量（m³）',
					},
					{
						key: 'standardInstantaneousFlow',
						name: '标况流量（m³/h）',
					},
					{
						key: 'workInstantaneousFlow',
						name: '工况流量（m³/h）',
					},
					{
						key: 'pressure',
						name: `压力（${this.pressureUnitName}）`,
					},
					{
						key: 'temperature',
						name: '温度（℃）',
					},
					{
						key: 'voltage',
						name: '电压（V）',
					},
					{
						key: 'remainingQuantity',
						name: '剩余量（m³）',
					},
					{
						key: 'remainingAmount',
						name: '剩余金额（元）',
					},
				]
			},
			immediate: true,
		},

		'form.deviceTypeClassify': {
			handler(newVal) {
				if (newVal) {
					this.form.deviceTypeIdList = []
				}
				this.queryDeviceTypeList()
			},
			immediate: true,
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
</style>
